// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2Sb0N","alert":"SettungsInbox_alert__1_0qt"};